import { useEffect } from "react";
import { RouterProvider } from "./router";
import { syncUserFromToken } from "entities/user";

export const Providers = () => {
  useEffect(() => {
    syncUserFromToken();
  }, []);
  return <RouterProvider />;
};
